import React, { useState, useEffect, useRef } from 'react';

import Tag from '../components/Tag';
import Button from '../components/Button';

import Headerbar from './Headerbar'

function CompoundPulley(props) {
  const bannerRef = useRef(null);
  const [height, setHeight] = useState(0);

  const Row = (props) => {
    return(<div className='border-t-[1px] border-blue p-[0.5rem] w-full h-fit keplersemi flex flex-row space-x-[0.5rem]'>
      {props.children}
    </div>)
  }

  useEffect(() => {
    const bannerHeight = () => {
      if (bannerRef.current && bannerRef.current.getBoundingClientRect().height !== height) {
        let h = bannerRef.current.getBoundingClientRect().height;
        setHeight(h)
      }
    }

    bannerHeight();
    window.addEventListener('resize', bannerHeight);
    setInterval(()=>{
      bannerHeight();
    }, 500)

    return () => {
      window.removeEventListener('resize', bannerHeight);
    }
  }, []);

    return (
    <div className='relative w-full flex flex-col justify-start items-center min-h-[840px] h-full text-blue pt-[4.5rem]'
      onMouseEnter={() => props.setHover({})}>
      <div className='flex my-auto w-full h-fit lg:max-h-[1000px] p-[1.5rem] md:p-[3rem] xl:px-[6rem] relative z-0 max-w-[2000px]'>
        <div className='min-h-fit h-full w-full flex flex-col md:flex-row items-start justify-start pb-[2rem] md:pb-0'>
          <div id='Banner' ref={bannerRef} className='w-full lg:w-1/2 xl:w-1/3 3xl:min-w-[500px] h-fit mb-[2rem] md:mb-0 md:mr-[1rem] fadein'>
            <div className='lg:max-w-[800px] driftinfast relative left-0 flex flex-col justify-start items-start h-fit min-h-full'>
              <a className='keplersemi text-blue w-fit inline md:hidden mb-[2rem]' href='/projects'>
              <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
              </a>


              <div className='w-full h-full flex flex-col justify-start'>
                <div>
                  <img className='mb-[1rem] w-[100%] h-auto max-w-[450px]' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/title.png' 
                  alt='compound pulley'/>
                  <div className='flex w-full h-fit py-[0.5rem] justify-start flex-wrap'>
                    <Tag text={'Part-time Research'}/>
                    <Tag text={'CAD'}/>
                    <Tag text={'Machining'}/>
                    <Tag text={'Performance Testing'}/>
                  </div>
                </div>

                <img className='object-contain aspect-square w-[30%]' src={require('../images/handerc.png')} alt='HAND ERC'/>
                
                <div className='w-full flex justify-start items-start my-[1rem]'>
                  <p className='min-w-[300px] text-start'>
                    The latter half of my junior year, I took on the challenge of designing a <mark>compound pulley system</mark> for tendon-driven robotic fingers, which would enable <mark>force amplification and easier tendon replacement in complex assemblies.</mark> I sketched and prototyped multiple termination methods, navigating the tradeoff between <mark>feature-richness and machinability at scale.</mark> 
                    <br/><br/>
                    After presenting my design process and gathering feedback at weekly lab meetings, I landed on a final design that I CNC-machined out of aluminum and put through real <mark>performance testing</mark> on the lab's custom tendon routing testbed. Seeing concrete data on my design's performance and the effect of factors like hysteresis gave me a much deeper appreciation for how much iteration goes into even the smallest mechanical components.
                  </p>
                </div>

                <div className='w-full text-blue keplersemi'>
                  <div className='flex w-full h-fit pt-0 justify-start items-start flex-col text-blue keplermed'>
                    <Row>
                      <div className='min-w-[8rem]'>DURATION</div>
                      <div className='flex flex-col justify-start items-start keplermed'>
                        <p>Jan 2026 ~ Jun 2026</p>
                      </div>
                    </Row>
                    <Row>
                      <div className='min-w-[8rem]'>SKILLS<br/>DEVELOPED</div>
                      <div className='flex flex-col justify-start items-start keplermed'>
                        <p>1) Iterative mechanical design</p>
                        <p>2) Design for manufacturability, tolerancing & fit design</p>
                        <p>3) Experimental testing, data analysis & presentation</p>
                      </div>
                    </Row>
                  </div>
                </div>

                <div className='w-full flex justify-start items-center keplersemi my-[1rem]'>
                  <Button ReducedMotion = {props.ReducedMotion} link={require('../images/projects/compoundpulley/presentation_slides.zip')} download={true}
                  setHover={props.setHover}>
                        <img className='h-[1rem] mr-[0.5rem] aspect-square object-contain' src={require('../images/download.png')} alt='download resume'/>
                        <div className='mt-[3px]'>PRESENTATION SLIDES</div>
                  </Button>
                </div>

                <a className='keplersemi text-blue w-fit hidden md:inline' href='/projects'>
                <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
                </a>
              </div>
            </div>
          </div>

          <div id='scroll' className='relative w-full lg:w-1/2 xl:w-2/3 3xl:w-full flex flex-row z-0 justify-start items-start pb-[2rem] md:pb-[1rem] md:pl-[1rem]' 
            style={{height: (window.innerWidth > 768) ? height : 'fit'}}>

            <div className='driftinleft hidden md:inline absolute -z-10 w-[100%] h-[100%] right-[1.5rem] top-[1rem] pl-[1.5rem] pb-[1rem]'>
              <img className='dropshadow object-cover w-full h-full' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/sand.png' 
              alt='textured background'/>
            </div>

            <div className='bg-white w-full h-fit md:h-full flex flex-col space-y-[0.5rem] justify-start items-start md:overflow-y-scroll'>
              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  BRAINSTORMED CONCEPTS
                </div>
              </div>
              <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/brainstorming_1.png' 
              alt='compound pulley concept 1'/>
              <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/brainstorming_3.png' 
              alt='compound pulley concept 2'/>
              <div className='w-full grid grid-cols-2 gap-2'>
                <img className='w-full aspect-square h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/brainstorming_2.png' 
                alt='concept exploded view'/>
                <img className='w-full aspect-square h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/brainstorming_4.png' 
                alt='concept exploded view'/>
              </div>


              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  FINAL DESIGN
                </div>
              </div>
              <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/final_design.png' 
              alt='final design'/>
              <div className='w-full grid grid-cols-1 gap-2'>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/slide_1.png' 
                alt='final design slide'/>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/slide_2.png' 
                alt='final design slide'/>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/slide_3.png' 
                alt='final design slide'/>
              </div>

              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  TESTING & OUTCOMES
                </div>
              </div>
              <div className='w-full h-fit flex flex-col space-y-[0.5rem]'>
                <video muted className='w-full h-[40rem] object-top object-cover' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/testing.mov' 
                alt='testing process'
                controls='on' autoplay='true' loop='true'/>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/slide_4.png' 
                alt='hysteresis plot'/>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/compoundpulley/slide_5.png' 
                alt='force transmission plot'/>
              </div>

              <a className='keplersemi text-blue w-fit lg:hidden my-[2rem]' href='/projects'>
                <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Headerbar {... props}/>
    </div> );
}

export default CompoundPulley;